import type { AxiosBasicCredentials } from 'axios'

import { ENV_CONFIG } from '../constants/envConfig'

export function getConsumerGatewayBasicAuth(): AxiosBasicCredentials {
  return {
    username: ENV_CONFIG.CONSUMER_GATEWAY_USERNAME,
    password: ENV_CONFIG.CONSUMER_GATEWAY_PASSWORD,
  }
}

export function getLocaleHeaders(locale: string) {
  return {
    'X-IBX-Locale': locale,
  }
}
